<template>
    <div class="app flex-row align-items-center animated fadeIn" id="login-form">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="card-group mb-0">
                        <div class="card p-4">
                            <div class="card-block">
                                <div id="login-logo"><img src="/static/img/logo.png"/></div>
                                <div class="alert alert-danger" v-show="error">
                                    {{ error }}
                                </div>
                                <div class="logout-message" v-show="isLoading">{{ $t('message.loading') }} <i
                                        class="fa fa-spinner fa-spin"
                                        aria-hidden="true"></i></div>
                                <div class="logout-message" v-show="isLoading">{{ step }}/{{ total }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import Storage from '../../api/Storage.js'
  import API from '../../api/API.js'
  import { orderBy } from 'lodash'
  import Helper from '../../api/Helper'

  export default {
    name: 'Loading',
    data () {
      return {
        step: 0,
        total: 8,
        isLoading: true,
        error: null
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        Helper.checkLang()
        // Опять промис хелл, блять
        API.getLastVersion().then(response => {
          this.step++
          Storage.lastVersion = response.data.last_version
          API.getLastUpdateTime().then(response => {
            this.step++
            Storage.lastUpdate = response.data.last_update
            API.getCountries().then(response => {
              this.step++
              if (Object.keys(response.data).length === 0) {
                this.isLoading = false
                this.error = this.$t('message.no_countries')
              } else {
                Storage.countries = orderBy(Object.keys(response.data).map(key => response.data[key]), ['name'], ['asc'])
                Storage.selectedCountry = Helper.findCountry(Storage.enterRouter.query.country_id)
                API.getOffers(Storage.selectedCountry.id).then(response => {
                  this.step++
                  Storage.offers = response.data
                  Storage.selectedOffer = Helper.findSelectedOffers(Storage.enterRouter.query.offer_id)
                  API.getWebmasters(Storage.selectedCountry.id).then(response => {
                    this.step++
                    Storage.webFilter = response.data
                    Storage.webSelectedFilter = Helper.findSelectedWebs(Storage.enterRouter.query.web_id)
                    API.getOperators(Storage.selectedCountry.id).then(response => {
                      this.step++
                      Storage.operators = Object.keys(response.data).map(key => response.data[key])
                      Storage.selectedOperator = Helper.findSelectedOperators(Storage.enterRouter.query.operator_id)
                      API.getCouriers().then(response => {
                        this.step++
                        Storage.couriers = Object.keys(response.data).map(key => response.data[key])
                        Storage.selectedCouriers = Helper.findSelectedCouriers(Storage.enterRouter.query.courier_id)
                        API.getDashboardStatistic().then(response => {
                          this.step++
                          Storage.dashboardStatistic = response.data
                          if (Storage.enterRouter.query.date_from && Storage.enterRouter.query.date_to) {
                            Storage.selectedDateFrom = new Date(Storage.enterRouter.query.date_from)
                            Storage.selectedDateTo = new Date(Storage.enterRouter.query.date_to)
                          }
                          this.isLoading = false
                          Vue.console.log(`Pushing to ${Storage.enterRouter.fullPath}`)
                          this.$router.push(Storage.enterRouter.fullPath)
                        })
                      })
                    })
                  })
                })
              }
            })
          }, () => {
            window.location = window.location.origin
          })
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Loading.vue?0896e096